<template>
  <div>

    <vx-card>

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="محصولات" icon-pack="feather" icon="icon-check">
            <div class="tab-text">
              <ManageProducts class="mt-4" />
            </div>
          </vs-tab>
          <vs-tab label="خدمات" icon-pack="feather" icon="icon-check">
            <div class="tab-text">
              <ManageServices class="mt-4" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import ManageProducts from "./manageProducts/Show.vue"
import ManageServices from "./manageServices/Show.vue"

// Store Module

export default {
  components: {
    ManageProducts,
    ManageServices,
  },
  data() {
    return {
      activeTab: 0,
    }
  },
  watch: {
  },

  methods: {
  },

  created() {
  }
}

</script>
